import { tcv } from "@choiceform/design-system"

export const JsEditorTv = tcv({
  slots: {
    container: "relative rounded-md border border-transparent min-w-0 overflow-hidden",
    editor: "w-full h-full",
    viewport: "h-full w-full",
    content: "flex flex-col",
  },

  variants: {
    variant: {
      default: {
        container: "bg-secondary-background",
      },
      light: {
        container: "bg-gray-100",
      },
      dark: {
        container: "bg-gray-700",
      },
      reset: {},
    },
    selected: {
      true: {},
      false: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    readOnly: {
      true: {
        editor: "cursor-default",
      },
      false: {},
    },
  },

  compoundVariants: [
    {
      variant: "default",
      selected: true,
      disabled: false,
      class: {
        container: [
          "bg-default-background",
          "not-focus-within:border-selected-boundary/50",
          "focus-within:border-selected-boundary",
        ],
      },
    },
    {
      variant: "default",
      selected: false,
      disabled: false,
      class: {
        container: "hover:not-focus-within:border-default-boundary",
      },
    },
    {
      variant: "light",
      selected: false,
      disabled: false,
      class: {
        container: ["hover:not-focus-within:border-gray-200"],
      },
    },
    {
      variant: "dark",
      selected: false,
      disabled: false,
      class: {
        container: ["hover:not-focus-within:border-gray-600"],
      },
    },
    {
      variant: ["light", "dark", "default"],
      selected: false,
      disabled: false,
      class: {
        container: "focus-within:border-selected-boundary",
      },
    },
    {
      variant: "default",
      disabled: true,
      class: {
        container: "border-secondary-background bg-secondary-background opacity-60",
      },
    },
    {
      variant: "light",
      disabled: true,
      class: {
        container: "bg-gray-100 opacity-60",
      },
    },
    {
      variant: "dark",
      disabled: true,
      class: {
        container: "bg-gray-700 opacity-60",
      },
    },
  ],

  defaultVariants: {
    variant: "default",
    selected: false,
    disabled: false,
    readOnly: false,
  },
})

